import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    TabbedComponent,
    TabComponentTab,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useAccount} from '../hooks/useAccount';
import {useAccountsSelection} from '../hooks/useAccountsSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {


    const {id: accountId} = useParams();

    if (typeof accountId === 'undefined') {
        throw new Error('accountId is required parameter');
    }

    const {
        record: account,
        fetchRecord,
        updateRecord,
    } = useAccount(accountId);

    const {handleClearSelection} = useAccountsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchRecord();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountId]);

    if (!account) {
        return <PlatformLoader message='Loading account...Please wait'/>;
    }

    const tabs = [] as TabComponentTab[];

    return (
        <FormPageLayout
            title={account.name ? account.name : account.id}
            pageNavigation={<EditPageNavigation component={account}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={account}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <TabbedComponent tabs={tabs}/>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={account}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
